import React, { useEffect, useState } from 'react';
import { Drawer, Button, Space, Typography, Tag, Descriptions, Divider, Input, Timeline, Modal, message } from 'antd';
import TargetTags from './TargetTags';
import { auditStatusInfo } from './auditMock';

const { Text, Title } = Typography;
const { TextArea } = Input;

// 定制申请审核抽屉（管理端）：申请信息 + 审核历史 + 通过 / 驳回
const AuditDrawer = ({ open, record, state, onClose, onApprove, onReject }) => {
    const [mode, setMode] = useState('view'); // view | reject
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (open) { setMode('view'); setReason(''); }
    }, [open, record]);

    const status = state?.status || 'pending';
    const info = auditStatusInfo(status);
    const history = state?.history || [];

    const doApprove = () => {
        Modal.confirm({
            title: '通过定制申请',
            content: `通过后企业将可填写资料。确认通过「${record?.appName || ''}」的定制申请？`,
            okText: '确认通过',
            cancelText: '取消',
            onOk: () => { onApprove(record.id); onClose(); message.success('已通过，已开放资料填写'); },
        });
    };

    const submitReject = () => {
        if (!reason.trim()) { message.warning('请填写驳回理由'); return; }
        onReject(record.id, reason.trim());
        onClose();
        message.success('已驳回，企业可修改后重新提交');
    };

    return (
        <Drawer
            title={`审核定制申请 · ${record?.appName || ''}`}
            open={open}
            width={720}
            onClose={onClose}
            footer={status === 'pending' ? (
                <Space style={{ float: 'right' }}>
                    {mode === 'view' ? (
                        <>
                            <Button danger onClick={() => setMode('reject')}>驳回</Button>
                            <Button type="primary" onClick={doApprove}>通过</Button>
                        </>
                    ) : (
                        <>
                            <Button onClick={() => { setMode('view'); setReason(''); }}>取消</Button>
                            <Button danger type="primary" onClick={submitReject}>确认驳回</Button>
                        </>
                    )}
                </Space>
            ) : (
                <Space style={{ float: 'right' }}><Button onClick={onClose}>关闭</Button></Space>
            )}
        >
            <Space size={8} style={{ marginBottom: 12 }}>
                <Tag color={info.adminColor} style={{ border: 'none' }}>{info.adminText}</Tag>
                <Text type="secondary" style={{ fontSize: 12 }}>审核通过前，企业与客服均不可填写资料（仅可只读预览）</Text>
            </Space>

            <Title level={5} style={{ marginTop: 0 }}>申请信息</Title>
            <Descriptions column={1} size="small">
                <Descriptions.Item label="应用名称">{record?.appName}</Descriptions.Item>
                <Descriptions.Item label="定制企业">{record?.companyName}（{record?.companyId}）</Descriptions.Item>
                <Descriptions.Item label="定制范围"><TargetTags targets={record?.targets} /></Descriptions.Item>
                <Descriptions.Item label="提交时间">{record?.createdAt}</Descriptions.Item>
            </Descriptions>

            <Divider style={{ margin: '12px 0' }} />
            <Title level={5} style={{ marginTop: 0 }}>审核历史</Title>
            {history.length ? (
                <Timeline items={history.map((h) => ({
                    color: h.action === 'reject' ? 'red' : h.action === 'approve' ? 'green' : 'blue',
                    children: (
                        <div>
                            <Text style={{ fontSize: 13 }}>{h.text}</Text>
                            <div><Text type="secondary" style={{ fontSize: 12 }}>{h.operator} · {h.time}</Text></div>
                        </div>
                    ),
                }))} />
            ) : <Text type="secondary" style={{ fontSize: 12 }}>暂无审核记录</Text>}

            {mode === 'reject' && (
                <>
                    <Divider style={{ margin: '12px 0' }} />
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>驳回理由（必填）</Text>
                    <TextArea rows={3} maxLength={200} showCount value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="请说明驳回原因，企业将据此修改后重新提交" />
                </>
            )}
        </Drawer>
    );
};

export default AuditDrawer;
